/**
 * Money helpers for visit / referral data.
 *
 * Phase 3.5 renamed `action_pending_payment_due_paise` (int paise) to
 * `action_pending_payment_due` (float rupees) on the visit row, and the
 * `referral_history` hop key from `payment_due_paise` to `payment_due`.
 * These helpers read both shapes so old rows keep rendering correctly
 * during the cutover. Callers always get rupees back.
 */

/** Visit row → rupees due (float). 0 when neither field is set. */
export function visitPaymentDueRupees(visit) {
  if (!visit) return 0;
  if (visit.action_pending_payment_due != null) {
    return Number(visit.action_pending_payment_due) || 0;
  }
  if (visit.action_pending_payment_due_paise != null) {
    return (Number(visit.action_pending_payment_due_paise) || 0) / 100;
  }
  return 0;
}

/** Single referral_history hop → rupees due (float). 0 when unset. */
export function hopPaymentDueRupees(hop) {
  if (!hop) return 0;
  if (hop.payment_due != null) {
    return Number(hop.payment_due) || 0;
  }
  if (hop.payment_due_paise != null) {
    return (Number(hop.payment_due_paise) || 0) / 100;
  }
  return 0;
}

/** Format rupees as "₹500" (no decimals when whole) or "₹500.50". */
export function formatRupees(rupees) {
  const n = Number(rupees) || 0;
  if (Number.isInteger(n)) return `₹${n}`;
  return `₹${n.toFixed(2)}`;
}
